import { Button } from '@/components/shadcn/Button';
import { DialogClose, DialogContent } from '@/components/dialog';
import Image from 'next/image';
import { useState } from 'react';
import { sendEvent } from '@/lib/firebase/analytics/sendEvent';
import { EVENTS } from '@/lib/firebase/analytics/events';
import { deleteCookies } from '@/actions/auth';
import { signOut } from 'firebase/auth';
import auth from '@/lib/firebase/client';

export function LogoutDialog() {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);

    try {
      await signOut(auth);

      // Firebaseイベント発火
      await sendEvent(EVENTS.log_out);

      await deleteCookies();
      location.href = '/login';
    } catch {
      // eslint-disable-next-line no-alert
      alert('ログアウトできませんでした。再度時間を置いてからお試しください。');
      setIsLoading(false);
    }
  };

  return (
    <>
      <DialogContent className="px-[20px]">
        <Image
          src="/static/images/icons/menu/logout.svg"
          width={100}
          height={100}
          alt="ログアウト"
          className="mx-auto mt-[42px] h-[52px] w-[52px]"
        />
        <p className="my-[10px] py-[10px] text-center font-semibold text-[#000]">
          ログアウトしますか？
        </p>
        <div className="mx-auto mb-[30px] flex gap-[30px]">
          <DialogClose asChild>
            <Button
              className={`w-[144px] rounded-[24px] border-2 border-solid border-primary py-[22px] font-semibold text-primary-500 ${
                isLoading ? '' : 'hover-animation'
              }`}
              disabled={isLoading}
            >
              キャンセル
            </Button>
          </DialogClose>
          <Button
            className={`${
              isLoading ? '' : 'hover-animation'
            } w-[144px] rounded-[24px] bg-primary-500 py-[22px] font-semibold text-white`}
            onClick={handleClick}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="h-7 w-7 animate-spin rounded-full border-4 border-white border-t-transparent" />
            ) : (
              'ログアウト'
            )}
          </Button>
        </div>
      </DialogContent>
    </>
  );
}
